export default __webpack_public_path__ + "static/media/o-400.f57a62e9.woff2";